<template>
    <form class="form-horizontal" style="margin-top: 20px" v-if="veiculo && veiculo.uuid">

        <div class="form-group">
          <label for="sinistro" class="col-sm-6 control-label text-danger">
            Ao habilitar a MANUTENÇÃO, todos os eventos e notificações serão descartados.
          </label>
        </div>

        <div class="form-group">
            <label for="oficina" class="col-sm-2 control-label">HABILITAR MANUTENÇÃO:</label>
            <div class="col-sm-3">
                <combo-true-false id="sinistro" v-model="veiculo.sinistro"></combo-true-false>
            </div>

            <label for="termino_sinistro" class="col-sm-2 control-label">DATA DE TERMINO:</label>
            <div class="col-sm-3">
                <input type="date" :disabled="! veiculo.sinistro" id="termino_oficina" v-model="veiculo.termino_sinistro" class="form-control">
            </div>
        </div>

        <div class="form-group">
            <label for="texto" class="col-sm-2 control-label text-uppercase">Observação:</label>
            <div class="col-sm-10">
                <textarea style="height: 50px !important;" maxlength="140" v-model="veiculo.sinistro_txt" aria-valuemax="140" class="form-control" id="texto" ></textarea>
                <small class="text-uppercase">Limite de 140 caracteres</small>
            </div>
        </div>

        <div class="form-group">
            <label for="termino_sinistro" class="col-sm-2 control-label"></label>
            <div class="col-sm-3">
                <button @click.prevent="salvar" class="btn btn-block btn-success btn-xs">SALVAR MANUTENÇÃO</button>
            </div>
        </div>
    </form>
</template>

<script>
import {Veiculo} from "../../class";
import ComboTrueFalse from '../../components/combos/ComboTrueFalse';

export default {
    name: "HabilitarSinistro",
    props: {
        veiculo: {
            default: null
        }
    },
    components: {
        ComboTrueFalse
    },
    methods: {
        salvar () {
            if (this.veiculo.sinistro && ! this.veiculo.termino_sinistro) {
                return toastr.error("A DATA DE TÉRMINO é obrigatória");
            }

            swal({
                title: 'Posso Confirmar?',
                text: "Habilitar o alerta de transmissão?",
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, pode habilitar!'
            }).then(() => {
                try {
                    Veiculo.manutencao(this.veiculo.uuid, this.veiculo.sinistro, this.veiculo.termino_sinistro, this.veiculo.sinistro_txt).then(() =>
                        this.$emit('reload', this.veiculo.id_veiculo)
                    );
                } catch (err) {
                    console.error(err);
                    return toastr.error("Não Habilitado");
                }
            });
        },
    }
}
</script>

<style scoped>

</style>
